<template>
  <BackNav :title="$t('setting.printTitle')" style="margin-bottom: 2.66667vw" />
  <div class="type">
    <van-radio-group v-model="type">
      <van-radio name="1" style="margin-bottom: 1.33333vw">58MM</van-radio>
      <van-radio name="2" style="margin-bottom: 1.33333vw">80MM</van-radio>
    </van-radio-group>
  </div>
  <div style="margin: 2.13333vw">
    <van-button round block type="primary" @click="submitHandler"> {{ $t('common.submit') }} </van-button>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import BackNav from '@/components/BackNav';
import { Toast } from 'vant';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const type = ref('');
const submitHandler = () => {
  if (type.value) {
    console.log(type.value);
  } else {
    Toast(t('setting.selectFirst'));
  }
};
</script>

<style lang="scss" scoped>
.type {
  padding: 20px;
  box-sizing: border-box;
}
</style>
